import {useEffect, useRef, useState} from 'react'

import ApexCharts, {ApexOptions} from 'apexcharts'
import {useSelectDeviceId} from '../../../_metronic/layout/core'
import {useThemeMode} from '../../../_metronic/partials'
import {getCSS, getCSSVariableValue} from '../../../_metronic/assets/ts/_utils'

function ColumnChartComponent({
  /* chartValues,*/
  // name,
  chartIndex,
  action,
  setAction,
  chartValues,
  chartArrayValues,
  dataIndex,
  graphicInformation,
  maxValue,
}: any) {
  const {SelectDeviceId} = useSelectDeviceId()
  /* const [values, setValues] = useState(
    graphicInformation.map((i: any) => [null, null, null, null, null, null, null, null, null, null])
  )*/
  const [values, setValues] = useState(
    SelectDeviceId.map((i: any) => [null, null, null, null, null, null, null, null, null, null])
  )

  const [xAxis, setXAxis] = useState(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'])
  /* const chartSeries = graphicInformation.map((i: any, index: number) => {
    return {
      name: i.description.includes('value') ? i.description.replace(' value', '') : i.description,
      data: values[index],
    }
  })*/
  let chartSeries = (chartArrayValues.length > 0 ? chartArrayValues : values)?.map(
    (i: any, index: number) => {
      return {
        name: i.name,
        data: values[index],
      }
    }
  )

  useEffect(() => {
    setValues(
      SelectDeviceId.map((i: any) => [null, null, null, null, null, null, null, null, null, null])
    )
  }, [SelectDeviceId])

  useEffect(() => {
    if (values.length < 1) {
      setValues(
        chartArrayValues.map((i: any) => [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ])
      )
    }
    /* chartSeries = chartArrayValues.map((i: any, index: number) => {
      return {
        name: i.name,
        data: values[index],
      }
    })*/
    // console.log('values')
  }, [chartArrayValues])

  //const [firstValue, setFirstValue] = useState(true)
  //const [values, setValues] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
  //const chartIndex = 1
  /*const [values, setValues] = useState(
    graphicInformation.map((i: any) => [null, null, null, null, null, null, null, null, null, null])
  )*/
  // const [xAxis, setXAxis] = useState(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'])

  /* const chartSeries = graphicInformation.map((i: any, index: number) => {
    return {
      name: i.description.includes('value') ? i.description.replace(' value', '') : i.description,
      data: values[index],
    }
  })*/

  /*const handleNewValue = (chartValues: any) => {
    setValues((prevValues: any) => {
      return prevValues.map((array: any, index: number) => {
        if (array.includes(null)) {
          const newArray = [...array]
          const nullIndex = newArray.indexOf(null)
          newArray[nullIndex] = chartValues[dataIndex]
          return newArray
        } else {
          setXAxis((prevXAxis: string[]) => {
            const lastXValue = parseInt(prevXAxis[prevXAxis.length - 1])
            const newXAxis = [...prevXAxis.slice(1), (lastXValue + 1).toString()]
            return newXAxis
          })
          return [...array.slice(1), chartValues[index]]
        }
      })
    })
    setAction(false)
  }*/

  const handleNewValue = (chartArrayValues: any[]) => {
    setValues((prevValues: any) => {
      return prevValues.map((array: any, index: number) => {
        if (array.includes(null)) {
          const newArray = [...array]
          const nullIndex = newArray.indexOf(null)
          newArray[nullIndex] = chartArrayValues[index]?.[`deneyDeger${dataIndex + 1}`] // Kullanılacak olan özellik

          return newArray
        } else {
          setXAxis((prevXAxis: string[]) => {
            const lastXValue = parseInt(prevXAxis[prevXAxis.length - 1])
            const newXAxis = [...prevXAxis.slice(1), (lastXValue + 1).toString()]
            return newXAxis
          })
          return [...array.slice(1), chartArrayValues[index]?.[`deneyDeger${dataIndex + 1}`]]
        }
      })
    })
    setAction(false)
  }

  useEffect(() => {
    if (action) {
      //handleNewValue(chartValues)
      handleNewValue(chartArrayValues)
    }
    // console.log('values')
  }, [action])

  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    ApexCharts.exec(`chart-${chartIndex}`, 'updateOptions', {
      series: chartSeries,
      xaxis: {
        categories: xAxis,
      },
    })
  }, [values])

  function getChartOptions(height: number): ApexOptions {
    const labelColor = getCSSVariableValue('--kt-gray-500')
    const borderColor = getCSSVariableValue('--kt-gray-200')
    const baseColor = getCSSVariableValue('--kt-success')
    //const secondaryColor = getCSSVariableValue('--kt-gray-300')
    const secondaryColor = getCSSVariableValue('--kt-primary')
    const tertiaryColor = getCSSVariableValue('--kt-danger')
    const windowWidth = window.innerWidth

    return {
      series: chartSeries,
      chart: {
        id: `chart-${chartIndex}`,
        fontFamily: 'inherit',
        type: 'bar',
        height: height,
        width: '100%',
        toolbar: {
          show: true, //Görsel İndirmek İçin Button
          export: {
            csv: {
              filename: 'sciencelabgraphics',
              columnDelimiter: ';',
              headerCategory: 'Category',
              headerValue: 'value',
            },
            svg: {
              filename: 'sciencelabgraphics',
            },
            png: {
              filename: 'sciencelabgraphics',
            },
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '80%',
          borderRadius: 5,
          dataLabels: {
            orientation: 'vertical', // Veri etiketlerini dikey olarak görüntüle
          },
        },
      },
      legend: {
        show: true,
      },
      dataLabels: {
        textAnchor: 'middle',
        enabled: true,
        style: {
          // colors: ['#E8F7F5'],
          colors: ['#393E46'],
          fontSize: '14px',
          fontWeight: 'bold',
          //fontFamily: 'Arial',
        },
        dropShadow: {
          // enabled: true,
          color: '#000',
          //blur: 1,
          //opacity: 0.5,
        },
      },
      stroke: {
        show: true,
        width: 3,
        colors: ['transparent'],
      },
      xaxis: {
        //  categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        categories: xAxis,
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        max: maxValue > 0 ? maxValue : 255,
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },

        y: {
          formatter: function (val) {
            return String(val)
          },
        },
      },
      colors: [baseColor, secondaryColor, tertiaryColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    }
  }

  return <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: 350, width: '80%'}} />
}

export default ColumnChartComponent
